// extracted by mini-css-extract-plugin
export default {"device-list-container":"iot-devices_device-list-container__VTLIA"};